// TODO: Update External = 'VIPClientType:External ,when ClientType is updated for wholesale clients
export enum VIPClientType {
  External = 'VIPClientType:',
  Internal = 'VIPClientType:Internal'
}
